import { render } from "./ContactSelectionList.vue?vue&type=template&id=5f9a7b12&scoped=true"
import script from "./ContactSelectionList.vue?vue&type=script&lang=js"
export * from "./ContactSelectionList.vue?vue&type=script&lang=js"

import "./ContactSelectionList.vue?vue&type=style&index=0&id=5f9a7b12&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f9a7b12"]])

export default __exports__